import React from "react";

import "./CheckInTag.scss";

interface ICheckinTagProps {
    className?: string;
    tag: string;
}

const CheckInTag: React.FC<ICheckinTagProps> = ({ className = "", tag }) => {
    return (
        <div className={`CheckInTag ${className}`}>
            <p className="tagWrapper">{tag}</p>
        </div>
    );
};

export default CheckInTag;
